// Material
import { styled } from '@mui/material/styles'
import { Chip, useTheme } from '@mui/material'
// Common
import { SeenStatusIcon } from '$common/icons/seen-status'
import { ReceivedStatusIcon } from '$common/icons/received-status'
import { SentStatusIcon } from '$common/icons/sent-status'
import { PendingStatusIcon } from '$common/icons/pending-status'
import { toLocale } from '$func/text'
import { PinIcon, AlternateEmailIcon } from '$common/icons'
import { UnseenChip } from '$common/chip'
import { t } from '$i18n'

const Container = styled('div')`
  display: flex;
  margin-right: auto;
  padding-right: 4px;
  height: 24px;
  align-items: center;
`

const MentionChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: 'white',
  height: 20,
  minWidth: 20,
  marginLeft: 4,
  ...theme.typography.body3,
  '.MuiChip-label': {
    display: 'flex',
    padding: 3,
  },
}))

interface Props {
  fromMe: boolean
  seen: boolean
  received: boolean
  unseen: number
  muted: boolean
  pinned: boolean
  isPending: boolean
  showStatusBar: boolean
  hasMarkAsUnread: boolean
  hasMention?: boolean
}

export function Status({
  fromMe,
  seen,
  received,
  unseen,
  muted,
  pinned,
  isPending,
  showStatusBar,
  hasMarkAsUnread,
  hasMention = false,
}: Props) {
  const theme = useTheme()
  return (
    <Container>
      {hasMention && (
        <MentionChip
          label={
            <AlternateEmailIcon
              sx={{ width: '14px', height: '14px', color: 'white' }}
            />
          }
        />
      )}

      {showStatusBar ? (
        isPending ? (
          <PendingStatusIcon />
        ) : unseen > 0 ? (
          <UnseenChip
            color={muted ? 'neutral500' : 'success500'}
            label={unseen > 99 ? t('chatList.tooManyUnseen') : toLocale(unseen)}
          />
        ) : hasMarkAsUnread ? (
          <UnseenChip />
        ) : fromMe ? (
          seen ? (
            <SeenStatusIcon />
          ) : received ? (
            <ReceivedStatusIcon />
          ) : (
            <SentStatusIcon />
          )
        ) : pinned ? (
          <PinIcon
            sx={{
              color: theme.palette.neutral500,
              width: '20px',
              height: '20px',
            }}
          />
        ) : null
      ) : null}
    </Container>
  )
}
